import { useState, useCallback } from "react";
import {
  ThemeEternal, ThemeSerenity, ThemeAmour, ThemeTwilight,
  ThemeIvory, ThemeBloom, ThemePriyayi, ThemePasundan, ThemeMinangkabau,
} from "./undangan";

// ── DATA DUMMY ────────────────────────────────────────────────
// Pakai flat fields karena wc() di undangan.jsx baca flat dulu,
// fallback ke content.* — jadi tidak perlu nested content: {}
const DUMMY_WEDDING = {
  id:              "demo-001",
  slug:            "demo",
  status:          "active",
  theme:           "eternal",
  groom_name:      "Reza",
  bride_name:      "Salsabila",
  groom_full:      "Reza Aditya Pratama, S.T.",
  bride_full:      "Salsabila Nur Fadhilah, S.Pd.",
  groom_father:    "Bapak Ahmad Fauzi",
  groom_mother:    "Ibu Sri Mulyani",
  bride_father:    "Bapak Hendra Wijaya",
  bride_mother:    "Ibu Ratna Dewi",
  akad_date:       "Sabtu, 12 Juli 2025",
  akad_time:       "08.00 – 10.00 WIB",
  resepsi_date:    "Sabtu, 12 Juli 2025",
  resepsi_time:    "11.00 – 14.00 WIB",
  target_date:     "2025-07-12T08:00:00",
  venue_name:      "Gedung Serbaguna Graha Indah",
  venue_address:   "Jl. Merdeka No. 12, Jakarta Selatan",
  venue_maps_url:  "https://maps.google.com",
  dress_code:      "Dark Green & Gold",
  love_story:      "Kami pertama bertemu di sebuah seminar pada 2019.\nDari satu senyuman sederhana, tumbuh rasa yang tak pernah kami duga.\nDua tahun pertemanan, satu tahun kedekatan, dan akhirnya satu langkah menuju selamanya.",
  wedding_date:    "2025-07-12",
  expires_at:      "2099-01-01",
  addons:          ["galeri_foto", "amplop_digital", "link_personal"],
  // gallery & banks dibaca via wcArr — letakkan di flat field
  gallery: [
    "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80",
    "https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=600&q=80",
    "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=600&q=80",
    "https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=600&q=80",
    "https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=600&q=80",
    "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=600&q=80",
  ],
  banks: [
    { bank: "BCA",     number: "1234 5678 90", holder: "Reza Aditya Pratama" },
    { bank: "Mandiri", number: "0987 6543 21", holder: "Salsabila Nur Fadhilah" },
  ],
  // content: {} kosong — wc() akan fallback ke flat fields di atas
  content: {},
};

const DUMMY_GUEST = {
  id:    "guest-demo",
  name:  "Budi Santoso",
  token: "demo-token",
};

// ── TEMA REGISTRY ─────────────────────────────────────────────
const THEMES = [
  { id:"eternal",     label:"Eternal",     sub:"Cinematic · Gold",       palette:["#0C0B09","#C9A84C","#1A1610"], dark:true,  Component: ThemeEternal },
  { id:"serenity",    label:"Serenity",    sub:"Editorial · Magazine",   palette:["#060D08","#7A9E7E","#0A1A0C"], dark:true,  Component: ThemeSerenity },
  { id:"amour",       label:"Amour",       sub:"Polaroid · Vintage",     palette:["#120608","#C97B6F","#1A0810"], dark:true,  Component: ThemeAmour },
  { id:"twilight",    label:"Twilight",    sub:"Asymmetric · Modern",    palette:["#08070F","#9B87B8","#0F0D1C"], dark:true,  Component: ThemeTwilight },
  { id:"ivory",       label:"Ivory",       sub:"Classical · Light",      palette:["#F5F0E8","#8B6F47","#EDE5D8"], dark:false, Component: ThemeIvory },
  { id:"bloom",       label:"Bloom",       sub:"Minimalist · Column",    palette:["#FAFAF7","#7A9E7E","#F2F5EF"], dark:false, Component: ThemeBloom },
  { id:"priyayi",     label:"Priyayi",     sub:"Adat Jawa · Keraton",    palette:["#1A1105","#C9A84C","#140E04"], dark:true,  Component: ThemePriyayi },
  { id:"pasundan",    label:"Pasundan",    sub:"Adat Sunda · Taman",     palette:["#F7F5EE","#5A7A56","#EFF5EE"], dark:false, Component: ThemePasundan },
  { id:"minangkabau", label:"Minangkabau", sub:"Adat Minang · Gadang",   palette:["#0F0505","#C9A84C","#B43C28"], dark:true,  Component: ThemeMinangkabau },
];

// ── ENVELOPE SCREEN (mirip undangan.jsx tapi standalone) ──────
const THEME_META = {
  eternal:     { bg:"#0C0B09", ac:"#C9A84C" },
  serenity:    { bg:"#060D08", ac:"#7A9E7E" },
  amour:       { bg:"#120608", ac:"#C97B6F" },
  twilight:    { bg:"#08070F", ac:"#9B87B8" },
  ivory:       { bg:"#F5F0E8", ac:"#8B6F47" },
  bloom:       { bg:"#FAFAF7", ac:"#7A9E7E" },
  priyayi:     { bg:"#1A1105", ac:"#C9A84C" },
  pasundan:    { bg:"#F7F5EE", ac:"#5A7A56" },
  minangkabau: { bg:"#0F0505", ac:"#C9A84C" },
};

// ── CSS ───────────────────────────────────────────────────────
const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500&family=Cormorant+Garamond:ital,wght@0,300;1,400&display=swap');
  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  html { scroll-behavior:smooth; }

  /* ── TOPBAR ── */
  .dm-topbar {
    position:fixed; top:0; left:0; right:0; z-index:9999;
    background:rgba(8,6,4,0.92);
    backdrop-filter:blur(14px); -webkit-backdrop-filter:blur(14px);
    border-bottom:1px solid rgba(201,168,76,.1);
    display:flex; align-items:center;
    padding:0 16px; height:52px;
    overflow-x:auto; overflow-y:hidden;
    scrollbar-width:none;
  }
  .dm-topbar::-webkit-scrollbar { display:none; }
  .dm-topbar-logo {
    font-family:'Cinzel',serif; font-size:.52rem; letter-spacing:.38em;
    color:rgba(201,168,76,.55); white-space:nowrap;
    padding-right:20px; border-right:1px solid rgba(201,168,76,.1);
    margin-right:14px; flex-shrink:0;
  }
  .dm-tab {
    padding:0 14px; height:52px;
    display:flex; flex-direction:column; align-items:center; justify-content:center;
    cursor:pointer; flex-shrink:0; position:relative;
    transition:opacity .2s; border:none; background:transparent;
  }
  .dm-tab:hover { opacity:.8; }
  .dm-tab-label {
    font-family:'Cinzel',serif; font-size:.46rem; letter-spacing:.16em;
    color:rgba(240,232,216,.38); white-space:nowrap; transition:color .2s;
  }
  .dm-tab-sub {
    font-size:.36rem; letter-spacing:.08em;
    color:rgba(240,232,216,.18); white-space:nowrap; margin-top:2px; transition:color .2s;
  }
  .dm-tab.active .dm-tab-label { color:rgba(240,232,216,.92); }
  .dm-tab.active .dm-tab-sub   { color:rgba(201,168,76,.6); }
  .dm-tab.active::after {
    content:''; position:absolute; bottom:0; left:14px; right:14px;
    height:2px; background:#C9A84C;
  }

  /* ── FRAME ── */
  .dm-frame { margin-top:52px; min-height:calc(100vh - 52px); position:relative; }

  /* ── LANDING ── */
  .dm-landing {
    min-height:calc(100vh - 52px); background:#0C0B09;
    display:flex; flex-direction:column; align-items:center; justify-content:center;
    padding:60px 28px; text-align:center;
  }
  .dm-landing-tag {
    font-family:'Cinzel',serif; font-size:.44rem; letter-spacing:.52em;
    color:rgba(201,168,76,.45); margin-bottom:28px;
  }
  .dm-landing-title {
    font-family:'Cinzel',serif; font-size:clamp(2rem,7vw,4rem);
    letter-spacing:.04em; margin-bottom:12px;
    color:rgba(240,232,216,.92); line-height:1.1;
  }
  .dm-landing-title span { color:#C9A84C; }
  .dm-landing-sub {
    font-family:'Cormorant Garamond',serif; font-style:italic;
    font-size:.95rem; color:rgba(240,232,216,.25); margin-bottom:52px;
  }
  .dm-grid {
    display:grid; grid-template-columns:repeat(3,1fr);
    gap:10px; max-width:860px; width:100%;
  }
  .dm-card {
    background:var(--card-bg); border:1px solid rgba(255,255,255,.06);
    padding:28px 20px; cursor:pointer; position:relative; overflow:hidden;
    transition:transform .2s, border-color .2s;
    text-align:left;
  }
  .dm-card:hover { transform:translateY(-3px); border-color:var(--card-ac); }
  .dm-card-bg {
    position:absolute; inset:0;
    background:radial-gradient(ellipse 80% 60% at 50% 0%, var(--card-ac) 0%, transparent 60%);
    opacity:.07; pointer-events:none;
  }
  .dm-card-adat {
    position:absolute; top:10px; right:10px;
    font-family:'Cinzel',serif; font-size:.32rem; letter-spacing:.2em;
    color:var(--card-ac); padding:2px 6px; border:1px solid; opacity:.6;
  }
  .dm-card-label {
    font-family:'Cinzel',serif; font-size:.68rem; letter-spacing:.18em;
    color:rgba(240,232,216,.88); margin-bottom:5px; position:relative;
  }
  .dm-card-sub {
    font-size:.38rem; letter-spacing:.1em;
    color:rgba(240,232,216,.28); margin-bottom:16px; position:relative;
  }
  .dm-card-swatches { display:flex; gap:5px; position:relative; }
  .dm-card-dot { width:8px; height:8px; border-radius:50%; }

  /* ── FLOATING BUTTONS ── */
  .dm-back {
    position:fixed; bottom:24px; left:24px; z-index:9999;
    padding:10px 18px; background:rgba(8,6,4,.88); backdrop-filter:blur(8px);
    border:1px solid rgba(201,168,76,.25); color:rgba(201,168,76,.75);
    font-family:'Cinzel',serif; font-size:.44rem; letter-spacing:.18em;
    cursor:pointer; transition:all .2s;
  }
  .dm-back:hover { border-color:rgba(201,168,76,.6); color:rgba(201,168,76,1); }
  .dm-guest-toggle {
    position:fixed; bottom:24px; right:24px; z-index:9999;
    padding:10px 18px; background:rgba(8,6,4,.88); backdrop-filter:blur(8px);
    border:1px solid rgba(255,255,255,.1); color:rgba(240,232,216,.4);
    font-family:'Cinzel',serif; font-size:.44rem; letter-spacing:.16em;
    cursor:pointer; transition:all .2s;
  }
  .dm-guest-toggle.on {
    border-color:rgba(201,168,76,.4); color:rgba(201,168,76,.8);
  }
  .dm-guest-toggle:hover { border-color:rgba(201,168,76,.4); }

  /* ── ENVELOPE ── */
  @keyframes envFadeUp { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }
  .dm-env-wrap { animation:envFadeUp 1.2s ease both; }
  .dm-env-btn  { cursor:pointer; transition:all .3s; }
  .dm-env-btn:hover { opacity:.7; }

  @media(max-width:760px) {
    .dm-grid { grid-template-columns:1fr 1fr; }
  }
  @media(max-width:480px) {
    .dm-grid { grid-template-columns:1fr; }
  }
`;

// ── MAIN DEMO ─────────────────────────────────────────────────
export default function Demo() {
  const [activeTheme, setActiveTheme] = useState(null);
  const [showGuest,   setShowGuest]   = useState(true);
  const [opened,      setOpened]      = useState(false);

  const switchTheme = useCallback((id) => {
    setActiveTheme(id);
    setOpened(false);
    window.scrollTo({ top:0, behavior:"instant" });
  }, []);

  const themeMeta = activeTheme ? THEMES.find(t => t.id === activeTheme) : null;
  const wedding   = activeTheme ? { ...DUMMY_WEDDING, theme: activeTheme } : DUMMY_WEDDING;
  const guest     = showGuest ? DUMMY_GUEST : null;

  // Envelope screen
  function renderEnvelope() {
    const m   = THEME_META[activeTheme] || THEME_META.eternal;
    const dark = themeMeta?.dark ?? true;
    const tx  = dark ? "rgba(240,232,216,.88)" : "rgba(28,28,22,.88)";
    const txm = dark ? "rgba(240,232,216,.3)"  : "rgba(28,28,22,.3)";
    return (
      <div style={{ minHeight:"calc(100vh - 52px)", background:m.bg,
                    display:"flex", alignItems:"center", justifyContent:"center",
                    padding:40, position:"relative", overflow:"hidden" }}>
        <style>{`
          @keyframes envFadeUp2{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
          .dm-env-wrap2{animation:envFadeUp2 1.2s ease both;}
        `}</style>
        <div style={{ position:"absolute", inset:0,
                      background:`radial-gradient(ellipse 55% 45% at 50% 50%, ${m.ac}0d, transparent 68%)`,
                      pointerEvents:"none" }}/>
        <div className="dm-env-wrap2" style={{ textAlign:"center", maxWidth:400, position:"relative", zIndex:2 }}>
          <div style={{ fontSize:".44rem", letterSpacing:".58em", color:m.ac,
                        opacity:.6, marginBottom:32, fontFamily:"'Cinzel',serif" }}>
            ✦ UNDANGAN PERNIKAHAN ✦
          </div>
          {guest && (
            <>
              <div style={{ fontSize:".6rem", color:txm, letterSpacing:".1em", marginBottom:6 }}>Kepada Yth.</div>
              <div style={{ fontSize:"1.1rem", fontStyle:"italic", color:`${m.ac}cc`, marginBottom:26,
                            fontFamily:"'Cormorant Garamond',serif" }}>{guest.name}</div>
            </>
          )}
          <div style={{ fontFamily:"'Cinzel',serif", fontSize:"clamp(2.8rem,11vw,5rem)",
                        lineHeight:.88, color:tx, letterSpacing:".02em" }}>
            {wedding.groom_name}
            <span style={{ display:"block", fontSize:".2em", fontStyle:"italic",
                           opacity:.18, margin:"12px 0", letterSpacing:".22em",
                           fontFamily:"'Cormorant Garamond',serif" }}>&amp;</span>
            <span style={{ color:m.ac }}>{wedding.bride_name}</span>
          </div>
          <div style={{ width:44, height:1, background:`${m.ac}33`, margin:"26px auto" }}/>
          <div style={{ fontSize:".5rem", letterSpacing:".28em", color:txm, fontFamily:"'Cinzel',serif" }}>
            {wedding.resepsi_date}
          </div>
          <button className="dm-env-btn" onClick={() => setOpened(true)}
            style={{ marginTop:38, padding:"12px 34px", background:"transparent",
                     border:`1px solid ${m.ac}44`, color:m.ac,
                     fontFamily:"'Cinzel',serif", fontSize:".5rem", letterSpacing:".26em" }}>
            ✦ Buka Undangan
          </button>
        </div>
      </div>
    );
  }

  // Render tema aktif
  function renderTheme() {
    const { Component } = themeMeta;
    return <Component wedding={wedding} guest={guest} />;
  }

  return (
    <>
      <style>{GLOBAL_CSS}</style>

      {/* ── TOPBAR ── */}
      <nav className="dm-topbar">
        <div className="dm-topbar-logo">✦ MYKISAH</div>
        {THEMES.map(t => (
          <button key={t.id}
            className={`dm-tab${activeTheme === t.id ? " active" : ""}`}
            onClick={() => switchTheme(t.id)}>
            <span className="dm-tab-label">{t.label}</span>
            <span className="dm-tab-sub">{t.sub.split(" · ")[0]}</span>
          </button>
        ))}
      </nav>

      {/* ── CONTENT ── */}
      <div className="dm-frame">
        {!activeTheme ? (

          /* LANDING */
          <div className="dm-landing">
            <div className="dm-landing-tag">✦ PREVIEW UNDANGAN ✦</div>
            <h1 className="dm-landing-title">Pilih Tema<br/><span>MyKisah</span></h1>
            <p className="dm-landing-sub">9 tema dengan layout yang benar-benar berbeda</p>
            <div className="dm-grid">
              {THEMES.map(t => (
                <div key={t.id} className="dm-card"
                  style={{ "--card-bg":t.palette[0], "--card-ac":t.palette[1] }}
                  onClick={() => switchTheme(t.id)}>
                  <div className="dm-card-bg"/>
                  {t.sub.includes("Adat") && <span className="dm-card-adat">ADAT</span>}
                  <div className="dm-card-label">{t.label}</div>
                  <div className="dm-card-sub">{t.sub}</div>
                  <div className="dm-card-swatches">
                    {t.palette.map((c,i) => (
                      <div key={i} className="dm-card-dot" style={{ background:c }}/>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

        ) : opened ? renderTheme() : renderEnvelope()}
      </div>

      {/* ── FLOATING CONTROLS ── */}
      {activeTheme && (
        <>
          <button className="dm-back" onClick={() => { setActiveTheme(null); setOpened(false); }}>
            ← Semua Tema
          </button>
          <button className={`dm-guest-toggle${showGuest ? " on" : ""}`}
            onClick={() => setShowGuest(g => !g)}>
            {showGuest ? "👤 Dengan Tamu" : "👤 Tanpa Tamu"}
          </button>
        </>
      )}
    </>
  );
}
